import { Client } from '@/utilities/api/Client';
import { ProductExclusionEndpoint } from '@api/endpoints';

export class ProductExclusionApi {
  static create (
    productId: string,
    body: ProductExclusionEndpoint.Create.Request,
  ): Promise<ProductExclusionEndpoint.Create.Response> {
    return Client(`product/${productId}/exclusions`, { body, method: 'POST' });
  }

  static delete (productId: string, id: string): Promise<void> {
    return Client(`product/${productId}/exclusions/${id}`, { method: 'DELETE' });
  }

  static list (productId: string): Promise<ProductExclusionEndpoint.List.Response> {
    return Client(`product/${productId}/exclusions`);
  }
}
